module.exports = "<div class=\"pr10\" #chartContainer></div>"